$(document).ready(function () {
	/* =============================
     ADD TO FAVORITES
  ============================= */
	// Initialize favorites from localStorage
	const FAVORITES_KEY = "cw_favorites";

	function getFavorites() {
		const favorites = localStorage.getItem(FAVORITES_KEY);
		return favorites ? JSON.parse(favorites) : [];
	}

	function saveFavorites(favorites) {
		localStorage.setItem(FAVORITES_KEY, JSON.stringify(favorites));
		updateFavoritesCount();
	}

	function updateFavoritesCount() {
		const favorites = getFavorites();
		const count = favorites.length;
		const $countBadge = $(".cw-favorites-count");

		if ($countBadge.length) {
			$countBadge.text(count);
			$countBadge.attr("data-count", count);
		}
	}

	function updateFavoriteButton($btn, isFavorite) {
		if (isFavorite) {
			$btn.addClass("is-favorite");
			$btn.find("path").attr("fill", "#e74c3c");
		} else {
			$btn.removeClass("is-favorite");
			$btn.find("path").attr("fill", "none");
		}
	}

	// Load existing favorites on page load and update count
	const favorites = getFavorites();
	updateFavoritesCount();

	$(".cw-card__favorite").each(function () {
		const $card = $(this).closest(".cw-card");
		const productUrl = $card.find(".cw-card__thumb").attr("href");

		if (productUrl && favorites.includes(productUrl)) {
			updateFavoriteButton($(this), true);
		}
	});

	// Handle favorite button clicks
	$(document).on("click", ".cw-card__favorite", function (e) {
		e.preventDefault();
		e.stopPropagation();

		const $btn = $(this);
		const $card = $btn.closest(".cw-card");
		const productUrl = $card.find(".cw-card__thumb").attr("href");
		const productTitle = $card.find(".cw-card__title").text();

		if (!productUrl) return;

		let favorites = getFavorites();
		const index = favorites.indexOf(productUrl);

		if (index > -1) {
			// Remove from favorites
			favorites.splice(index, 1);
			updateFavoriteButton($btn, false);
			console.log(`Removed "${productTitle}" from favorites`);
		} else {
			// Add to favorites
			favorites.push(productUrl);
			updateFavoriteButton($btn, true);
		}

		saveFavorites(favorites);
	});
});

/**
 * Custom jQuery-based Quantity Input Handler
 * Handles plus/minus buttons for quantity inputs
 */

(function ($) {
	"use strict";

	// Initialize quantity inputs
	function initQuantityInputs() {
		$(".quantity__button")
			.off("click")
			.on("click", function (e) {
				e.preventDefault();

				const $button = $(this);
				const $quantityInput = $button.closest("quantity-input");
				const $input = $quantityInput.find(".quantity__input");
				const buttonName = $button.attr("name");

				// Get current value and constraints
				let currentValue = parseInt($input.val()) || 1;
				const minValue = parseInt($input.attr("min")) || 1;
				const maxValue = parseInt($input.attr("max")) || 99999;
				const step = parseInt($input.attr("step")) || 1;

				// Calculate new value
				let newValue = currentValue;

				if (buttonName === "plus") {
					newValue = Math.min(currentValue + step, maxValue);
				} else if (buttonName === "minus") {
					newValue = Math.max(currentValue - step, minValue);
				}

				// Update input value if changed
				if (newValue !== currentValue) {
					$input.val(newValue).trigger("change");
				}

				// Update button states
				updateButtonStates(
					$quantityInput,
					newValue,
					minValue,
					maxValue,
				);
			});

		// Handle direct input changes
		$(".quantity__input")
			.off("input change")
			.on("input change", function () {
				const $input = $(this);
				const $quantityInput = $input.closest("quantity-input");
				let value = parseInt($input.val());
				const minValue = parseInt($input.attr("min")) || 1;
				const maxValue = parseInt($input.attr("max")) || 99999;

				// Validate value
				if (isNaN(value) || value < minValue) {
					value = minValue;
					$input.val(value);
				} else if (value > maxValue) {
					value = maxValue;
					$input.val(value);
				}

				// Update button states
				updateButtonStates($quantityInput, value, minValue, maxValue);
			});

		// Initialize button states on load
		$("quantity-input").each(function () {
			const $quantityInput = $(this);
			const $input = $quantityInput.find(".quantity__input");
			const value = parseInt($input.val()) || 1;
			const minValue = parseInt($input.attr("min")) || 1;
			const maxValue = parseInt($input.attr("max")) || 99999;

			updateButtonStates($quantityInput, value, minValue, maxValue);
		});
	}

	// Update button disabled states
	function updateButtonStates($quantityInput, value, minValue, maxValue) {
		const $minusBtn = $quantityInput.find(
			'.quantity__button[name="minus"]',
		);
		const $plusBtn = $quantityInput.find('.quantity__button[name="plus"]');

		// Disable minus button if at minimum
		if (value <= minValue) {
			$minusBtn.addClass("disabled").attr("disabled", true);
		} else {
			$minusBtn.removeClass("disabled").removeAttr("disabled");
		}

		// Disable plus button if at maximum
		if (value >= maxValue) {
			$plusBtn.addClass("disabled").attr("disabled", true);
		} else {
			$plusBtn.removeClass("disabled").removeAttr("disabled");
		}
	}

	// Initialize on DOM ready
	$(document).ready(function () {
		initQuantityInputs();
	});

	// Reinitialize after AJAX content updates
	$(document).on("shopify:section:load", function () {
		initQuantityInputs();
	});

	// Export for manual reinitialization if needed
	window.reinitQuantityInputs = initQuantityInputs;
})(jQuery);

jQuery(document).ready(function ($) {
	// ===============================
	// SHOW POPUP ONLY ONCE
	// ===============================
	if (!localStorage.getItem("cwPopupShown")) {
		setTimeout(function () {
			$("#cwLogin").fadeIn();
		}, 3000); // show after 3 seconds
	}

	// ===============================
	// HANDLE FORM SUBMISSION (without AJAX)
	// ===============================
	$("#newsletter_form").on("submit", function (e) {
		e.preventDefault();

		var $form = $(this);
		var email = $form.find('input[type="email"]').val().trim();

		if (!email) {
			alert("Please enter your email address.");
			return;
		}

		// Disable button while submitting
		var $button = $form.find('button[type="submit"]');
		$button.prop("disabled", true).text("Sending...");

		// Submit the form normally
		this.submit();

		// Show success message after short delay (you can customize)
		setTimeout(function () {
			$form.hide();
			$(".cw-login__success").fadeIn();
			localStorage.setItem("cwPopupShown", "true");
			$button.prop("disabled", false).text("Subscribe");
		}, 1000);
	});

	// ===============================
	// CLOSE POPUP
	// ===============================
	$("[data-close]").on("click", function () {
		localStorage.setItem("cwPopupShown", "true"); // mark as shown
		$("#cwLogin").fadeOut();
	});

	// fancybox
	Fancybox.bind("[data-fancybox]", {
		Carousel: {
			Thumbs: false,
			Toolbar: {
				display: {
					left: [],
					middle: [],
					right: ["close"],
				},
			},
			Zoomable: {
				Panzoom: {
					clickAction: "iterateZoom",
					maxScale: 2,
				},
			},
		},
	});

	// === galerry filter

	$(".filter__button").on("click", function () {
		$(".filter__button").removeClass("filter__button--active");
		$(this).addClass("filter__button--active");

		$(".cw-gallery__item").hide();

		let id = $(this).attr("id");

		if (id === "all") {
			$(".cw-gallery__item").show();
		} else {
			$(`.item-${id}`).show();
		}
	});

	// Just copy the price text from the existing price element on the page
	var priceText = $(".price-item--regular").first().text().trim();
	priceText = priceText.replace("From ", "");

	$(".add_to_cart_buttons_wrapper")
		.find(".btn-price .price-item--regular")
		.text(" - " + priceText);

	$(".cw-confirmation-button").on("click", function (e) {
		e.preventDefault();

		const $checkbox = $("#confirmCheck");

		if (!$checkbox.is(":checked")) {
			// Shake animation hint
			const $checkWrap = $(".cw-login__confirm-check");
			$checkWrap.css("animation", "none");
			$checkWrap[0].offsetHeight; // reflow
			$checkWrap.css("animation", "cw-shake 0.3s ease");

			// Show error text with fade
			if ($(".cw-confirm-error").length === 0) {
				$(this).after(
					'<p class="cw-confirm-error">Please confirm before continuing.</p>',
				);
			}
			// Small timeout to allow DOM paint before fade in
			setTimeout(function () {
				$(".cw-confirm-error").css("opacity", "1");
			}, 10);

			return false;
		}

		// Fade out and remove error if exists
		$(".cw-confirm-error").css("opacity", "0");
		setTimeout(function () {
			$(".cw-confirm-error").remove();
		}, 300);

		$(".add-to-cart-form").submit();
		$(".cw-login__close[data-close]").click();
	});

	$(document).on(
		"change",
		".product__info-wrapper input, .product__info-wrapper select",
		function () {
			// wait for Shopify to update disabled radios
			setTimeout(function () {
				$(
					'.product__info-wrapper input[type="radio"].disabled:checked',
				).each(function () {
					const name = $(this).attr("name");

					// uncheck disabled
					$(this).prop("checked", false);

					// find first available
					const $available = $(
						'.product__info-wrapper input[name="' +
							name +
							'"]:not(.disabled)',
					).first();

					if ($available.length) {
						$available.prop("checked", true);

						// IMPORTANT: trigger change so Shopify updates variant + image
						$available[0].dispatchEvent(
							new Event("change", { bubbles: true }),
						);
					}
				});
			}, 100);

			// wait for Shopify to update disabled radios
			setTimeout(function () {
				// Just copy the price text from the existing price element on the page
				var priceText = $(".price-item--regular").first().text().trim();
				priceText = priceText.replace("From ", "");

				$(".add_to_cart_buttons_wrapper")
					.find(".btn-price .price-item--regular")
					.text(" - " + priceText);
			}, 200);

			//  galley carosole

			const swiper = new Swiper(".cw-slider__inner", {
				slidesPerView: 1,
				loop: true,

				navigation: {
					nextEl: ".cw-slider__arrow--next",
					prevEl: ".cw-slider__arrow--prev",
				},
				breakpoints: {
					640: { slidesPerView: 2, spaceBetween: 16 },
					1024: { slidesPerView: 4, spaceBetween: 24 },
				},
			});

			// Filter buttons
			$(".filter__button").on("click", function () {
				// Update active state
				$(".filter__button").removeClass("filter__button--active");
				$(this).addClass("filter__button--active");

				const category = $(this).data("filter");

				$(".swiper-slide").each(function () {
					const $item = $(this).find(".cw-gallery__item");
					if (!$item.length) return;

					if (
						category === "all" ||
						$item.data("category") === category
					) {
						$(this).show();
					} else {
						$(this).hide();
					}
				});

				swiper.update();
			});
		},
	);
});

$(document).ready(function () {
	const observer = new IntersectionObserver(
		function (entries) {
			$.each(entries, function (i, entry) {
				if (entry.isIntersecting) {
					const $img = $(entry.target);
					$img.attr("src", $img.data("src"));
					$img.removeClass("lazy");
					observer.unobserve(entry.target);
				}
			});
		},
		{
			rootMargin: "200px",
			threshold: 0.01,
		},
	);

	$(".lazy").each(function () {
		// alert('lazy')
		observer.observe(this);
	});
});

// Media Player
/* ════════════════════════════════════════════════════════════
   HeroBanner — jQuery version
   Requires: jQuery 3.x+
   Usage: include this file after jQuery, then it self-inits on DOM ready.
   ════════════════════════════════════════════════════════════ */

const HeroBanner = (() => {
	const $backdrop = $("#ytBackdrop");
	const $iframe = $("#ytIframe");
	const $closeBtn = $("#ytClose");
	const $titleEl = $("#ytTitle");
	const $ytLink = $("#ytLink");
	const $ytExtLink = $("#ytExtLink");

	let $previousFocus = null;

	/* Build YouTube privacy-enhanced embed URL */
	function embedUrl(id) {
		return `https://www.youtube-nocookie.com/embed/${id}?autoplay=1&rel=0&modestbranding=1&playsinline=1`;
	}

	/* Open modal and load video */
	function openModal(youtubeId, videoTitle) {
		const watchUrl = `https://www.youtube.com/watch?v=${youtubeId}`;
		$previousFocus = $(document.activeElement);

		$iframe.attr("src", embedUrl(youtubeId));
		$titleEl.text(videoTitle || "");
		$ytLink.attr("href", watchUrl);
		$ytExtLink.attr("href", watchUrl);

		$backdrop.addClass("is-open");
		$("body").css("overflow", "hidden");

		setTimeout(() => $closeBtn.trigger("focus"), 50);
	}

	/* Close modal and stop video */
	function closeModal() {
		$backdrop.removeClass("is-open");
		$iframe.attr("src", ""); /* clears src — stops audio/video */
		$("body").css("overflow", "");

		if ($previousFocus) $previousFocus.trigger("focus");
	}

	/* Backdrop click — close only when clicking the dark area itself */
	$backdrop.on("click", function (e) {
		if ($(e.target).is($backdrop)) closeModal();
	});

	/* Close button click */
	$closeBtn.on("click", closeModal);

	/* Escape key */
	$(document).on("keydown", function (e) {
		if (e.key === "Escape" && $backdrop.hasClass("is-open")) closeModal();
	});

	/* ── Public API ─────────────────────────────────────────── */
	return {
		/**
		 * Wire up hero banners.
		 *
		 * Option A (plain HTML already in the DOM):
		 *   Just call HeroBanner.init() — play button wires itself via
		 *   the parent element's data-youtube-id attribute.
		 *
		 * Option B (data-attribute driven, no inner HTML needed):
		 *   <div class="hero-banner"
		 *        data-image="photo.jpg"
		 *        data-title-line1="Crafted by Hand,"
		 *        data-title-line2="Built to Last"
		 *        data-youtube-id="VIDEO_ID"
		 *        data-video-title="My Film">
		 *   </div>
		 *
		 * @param {string} selector — defaults to '.hero-banner'
		 */
		init(selector = ".hero-banner") {
			$(selector).each(function () {
				const $el = $(this);

				/* Auto-build inner HTML when using data-image (Option B) */
				if (
					$el.data("image") &&
					$el.find(".hero-banner__bg").length === 0
				) {
					const line1 = $el.data("title-line1") || "";
					const line2 = $el.data("title-line2") || "";

					$el.html(`
            <div class="hero-banner__bg" style="background-image:url('${$el.data("image")}')"></div>
            <div class="hero-banner__overlay"></div>
            <div class="hero-banner__body">
              <h1 class="hero-banner__title">${line1}${line2 ? "<br>" + line2 : ""}</h1>
            </div>
            <button class="hero-banner__play" aria-label="Play video">
              <span class="hero-banner__play-icon"></span>
            </button>
          `);
				}

				const $playBtn = $el.find(".hero-banner__play");
				const youtubeId = $el.data("youtube-id") || "";
				const videoTitle = $el.data("video-title") || "";

				if (!$playBtn.length || !youtubeId) return;

				$playBtn.on("click", () => openModal(youtubeId, videoTitle));
			});
		},

		/* Expose open/close for external use */
		openModal,
		closeModal,
	};
})();

/* Self-init on DOM ready */
$(document).ready(() => HeroBanner.init());

// share option
$(document).ready(function () {
	const $shareBtn = $("#share-btn");

	// Check if the button exists and the browser supports the Web Share API
	if ($shareBtn.length && navigator.share) {
		$shareBtn.on("click", async function () {
			try {
				await navigator.share({
					title: $(this).data("title"),
					url: $(this).data("url"),
				});
			} catch (err) {
				console.error("Error sharing:", err);
			}
		});
	} else {
		// Hide the button if not supported
		if ($shareBtn.length) {
			$shareBtn.hide();
		}
	}
});

// document.addEventListener("DOMContentLoaded", function () {
//   var sticky = new Sticky('.product__column-sticky',{
// 			topSpacing: 60,
// 		});
// });

(function () {
	const el = document.querySelector(".scroll-trigger");
	if (!el) return;

	const TOP_OFFSET = 200; // sticky offset from top when scrolling up

	let lastScrollY = window.scrollY;
	let currentTop = TOP_OFFSET;
	let ticking = false;

	function update() {
		const scrollY = window.scrollY;
		const delta = scrollY - lastScrollY;
		const viewportHeight = window.innerHeight;
		const elHeight = el.offsetHeight;

		// If element fits in viewport (accounting for top offset), just pin to top
		if (elHeight <= viewportHeight - TOP_OFFSET) {
			el.style.top = TOP_OFFSET + "px";
			lastScrollY = scrollY;
			ticking = false;
			return;
		}

		// Sticky range:
		//   maxTop = TOP_OFFSET            → top edge sticks 200px from viewport top
		//   minTop = viewportHeight - elHeight → bottom edge sticks at viewport bottom
		const maxTop = TOP_OFFSET;
		const minTop = viewportHeight - elHeight;

		const rect = el.getBoundingClientRect();

		if (delta > 0) {
			// scrolling DOWN — let it move up with page until bottom hits viewport bottom
			if (rect.bottom > viewportHeight) {
				currentTop = currentTop - delta;
			}
		} else if (delta < 0) {
			// scrolling UP — let it move down with page until top hits TOP_OFFSET line
			if (rect.top < TOP_OFFSET) {
				currentTop = currentTop - delta;
			}
		}

		// Clamp within valid sticky range
		currentTop = Math.max(minTop, Math.min(maxTop, currentTop));
		el.style.top = currentTop + "px";

		lastScrollY = scrollY;
		ticking = false;
	}

	function onScroll() {
		if (!ticking) {
			requestAnimationFrame(update);
			ticking = true;
		}
	}

	window.addEventListener("scroll", onScroll, { passive: true });
	window.addEventListener("resize", onScroll, { passive: true });
})();
